import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20manga%20and%20comic%20art%20collage%20featuring%20explosive%20action%20scenes%20with%20flowing%20ink%20effects%20in%20crimson%20red%20and%20golden%20accents%2C%20abstract%20speed%20lines%20and%20motion%20blur%20against%20dark%20background%2C%20vibrant%20energy%20waves%2C%20modern%20anime%20aesthetic%2C%20high%20contrast%20dramatic%20lighting%2C%20no%20text%2C%20clean%20composition&width=1920&height=1080&seq=hero-bg-manga-01&orientation=landscape"
        alt="汗汗漫画 - 更新最快的漫画网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h1 className="font-heading font-black text-5xl md:text-7xl lg:text-8xl tracking-tighter text-white leading-none">
          汗汗漫画
        </h1>
        <p className="mt-5 md:mt-6 font-serif text-xl md:text-2xl lg:text-3xl italic text-white/90">
          更新最快的漫画网
        </p>
        <p className="mt-8 md:mt-10 text-sm md:text-base text-white/60 max-w-lg mx-auto leading-relaxed">
          好看的免费漫画大全 · 无遮挡韩漫
        </p>
        <div className="mt-10 md:mt-12">
          <Link
            to="/category/all"
            className="inline-block px-10 md:px-14 py-3.5 md:py-4 bg-white text-foreground-900 font-semibold text-sm md:text-base rounded-full hover:bg-primary-500 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即开始阅读
          </Link>
        </div>

        <div className="mt-14 md:mt-16 flex items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-black text-white font-heading">50,000+</p>
            <p className="text-xs md:text-sm text-white/50 mt-1">漫画资源</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-black text-white font-heading">每日</p>
            <p className="text-xs md:text-sm text-white/50 mt-1">极速更新</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-black text-white font-heading">800万+</p>
            <p className="text-xs md:text-sm text-white/50 mt-1">活跃读者</p>
          </div>
        </div>
      </div>
    </section>
  );
}